import React, { useEffect, useState } from 'react';
import {DatePicker} from 'antd';
import dayjs from 'dayjs';
import 'dayjs/locale/en';
import CalendarIcon from "../CustomIcons/CalendarIcon";

const dateRender = (current) => {
  const style = {};
  if (current.format('YYYY-MM-DD HH:mm') === dayjs().format('YYYY-MM-DD HH:mm')) {
    style.border = '1px solid grey';
    style.borderRadius = '50%';
    style.background = 'grey'
  }
  return (
    <div className="ant-picker-cell-inner" style={style}>
      {current.date()}
    </div>
  );
};


const DateTimeField = ({ initialValue, dateFormat = 'YYYY-MM-DD HH:mm', offset = 0, onChange, ...restProps }) => {
  const [value, setValue] = useState(null);

  useEffect(() => {
    let defaultValue = dayjs();

    if (offset !== 0) {
      defaultValue = defaultValue.add(offset, 'day');
    }

    if (initialValue) {
      defaultValue = dayjs(initialValue);
    }
    setValue(defaultValue);
    handleDateChange(defaultValue);
  }, [initialValue, offset]);

  const handleDateChange = (date) => {
    setValue(date);
    if (onChange) {
      onChange(date ? date.format(dateFormat) : '');
    }
  };

  const getPopupContainer = (trigger) => {
    return trigger.parentNode;
  };

  return (
    <DatePicker
      {...restProps}
      showTime
      defaultValue={dayjs()} // Set defaultValue to current date
      value={value}
      format={dateFormat}
      onChange={handleDateChange}
      locale="en" // set locale here
      dateRender={dateRender}
      style={{width: '100%'}}
      getPopupContainer={getPopupContainer}
      suffixIcon={<CalendarIcon />}
    />
  );
};

export default DateTimeField;
